'use strict';

var Hounisen = Hounisen || {};
Hounisen.universeSearch = new function () {

    function init() {
        // Init functions
        Search();
    }

    function Search()
    {
            var forms = document.querySelectorAll(".usearchform")

            //prevent default form submit
            forms.forEach(function(form){
                form.addEventListener("submit", function(e){
                    e.preventDefault();

                    //get value of input
                    var q = form.querySelector("input").value;
                    var searchPage = form.querySelector("input").getAttribute("data-searchpage");
                    var url = searchPage + "?q=" + q;

                    //redirect to search page
                    window.location.href = url;

                })
            })

    }


    return {
        init: init,
    };
}();
